module.exports = {
  AUDIO: 'Audio',
  VIDEO: 'Video'
};



//////////////////
// WEBPACK FOOTER
// ./src/base/util/Const.js
// module id = 43
// module chunks = 0